// table row heads <th> set to position absolute —causing their height not to expand with the table rows.
function setRowHeadsSize() {
  const table = document.querySelector('.gdc-comparison-table__section .gdc-comparison-table')
  const rowHeads = document.querySelectorAll('.gdc-comparison-table__section .head-column')
  rowHeads.forEach((rowHead) => {
    const rowHeight = rowHead.closest('tr').offsetHeight
    rowHead.style.height = `${rowHeight - 1}px`
    rowHead.style.width = `${getRowHeadWidth(rowHeads)}px`
    // adds a margin left of the table to align entries not floating left
    table.style.marginLeft = `${getRowHeadWidth(rowHeads)}px`
  })
}

function getRowHeadWidth(rowHeads) {
  // returns width of widest row head
  const headWidths = [...rowHeads].map((rowHead) => parseFloat(rowHead.offsetWidth))
  return Math.max(...headWidths)
}

function toggleTriggers(section) {
  const triggers = section.querySelectorAll('.gdc-comparison-table__btn')
  triggers.forEach((trigger) => trigger.classList.toggle('active'))
}

function toggleRows(section) {
  const rows = section.querySelectorAll('.collapsible-row')
  rows.forEach((row) => row.classList.toggle('active'))
}

function handleChartVisibility(event) {
  const section = event.target.closest('.gdc-comparison-table__section')
  toggleTriggers(section)
  toggleRows(section)
  setRowHeadsSize()
}
